module.exports = __webpack_public_path__ + "img/NOVG.95b4d8f6.png";